var _a;
var keys = {
    gadventures: "gadventures",
    intrepid: "intrepid",
    urbanadventures: "urban_adventures",
    viator: "viator",
};
export var partnerActivityProviders = (_a = {},
    _a[keys.gadventures] = {
        id: keys.gadventures,
        name: "G Adventures",
    },
    _a[keys.viator] = {
        id: keys.viator,
        name: "Viator",
    },
    _a[keys.intrepid] = {
        id: keys.intrepid,
        name: "Intrepid",
    },
    _a[keys.urbanadventures] = {
        id: keys.urbanadventures,
        name: "Urban Adventures",
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/partnerActivityProviders.ts
// module id = Bz8k
// module chunks = 2